<template>
  <Main>
    <ToolsPanel
      :breadCrumbFirst="$t('bayerInfo.breadcrumb')"
      :breadCrumbFirstLink="'/'"
      :title="$t('bayerInfo.title')"
    >
    </ToolsPanel>
    <ContentContainer>
      <div class="static">
        <h1>{{ $t("bayerInfo.title") }}</h1>
        <h2>{{ $t("bayerInfo.accessTitle") }}</h2>
        <ul>
          <ol>
            {{
              $t("bayerInfo.access1")
            }}
          </ol>
          <ol>
            {{
              $t("bayerInfo.access2")
            }}
          </ol>
          <ol>
            {{
              $t("bayerInfo.access3")
            }}
          </ol>
          <ol>
            {{
              $t("bayerInfo.access4")
            }}
          </ol>
          <ol>
            {{
              $t("bayerInfo.access5")
            }}
          </ol>
          <ol>
            {{
              $t("bayerInfo.access6")
            }}
          </ol>
          <ol>
            {{
              $t("bayerInfo.access7")
            }}
          </ol>
        </ul>
        <h2>{{ $t("bayerInfo.reportTitle") }}</h2>
        <p>{{ $t("bayerInfo.report1") }}</p>
        <p>{{ $t("bayerInfo.report1Note") }}</p>
        <img src="/image/b-1.png" alt="" />
        <p>{{ $t("bayerInfo.report2") }}</p>
        <ul>
          <li>{{ $t("bayerInfo.report2a") }}</li>
          <li>{{ $t("bayerInfo.report2b") }}</li>
          <li>{{ $t("bayerInfo.report2c") }}</li>
          <li>{{ $t("bayerInfo.report2d") }}</li>
        </ul>
        <p>{{ $t("bayerInfo.report3") }}</p>
        <p>{{ $t("bayerInfo.report4") }}</p>
        <p>{{ $t("bayerInfo.report4Note") }}</p>
        <img src="/image/b-2.png" alt="" />
        <h2>{{ $t("bayerInfo.toolTitle") }}</h2>
        <p>{{ $t("bayerInfo.tool1") }}</p>
        <p>{{ $t("bayerInfo.tool2") }}</p>
        <img src="/image/b-3.png" alt="" />
        <h2>{{ $t("bayerInfo.campaignTitle") }}</h2>
        <p>{{ $t("bayerInfo.campaignFormat") }}</p>
        <p><b>AccountID_CampaignName_BuyerID</b></p>
        <p>{{ $t("bayerInfo.campaignExampleLabel") }}</p>
        <p>1234567890_TeslaX_AA88</p>
        <p class="red">{{ $t("bayerInfo.campaignWarning") }}</p>
        <p class="bottom">
          {{ $t("bayerInfo.noFbId") }} <span>{{ $t("bayerInfo.profit") }}</span>
        </p>
      </div>
    </ContentContainer>
  </Main>
</template>

<script>
import Main from "~/templates/Main.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";

export default {
  name: "Bayer Info",
  metaInfo: {
    title: "API",
  },
  data() {
    return {};
  },
  components: {
    Main,
    ToolsPanel,
    ContentContainer,
  },
  mounted() {},

  methods: {
    getUrl() {
      return process.env.VUE_APP_API;
    },
  },
};
</script>

<style lang="scss" scoped>
.static {
  h1 {
    font-size: 30px;
    padding-bottom: 20px;
    font-weight: 700;
  }

  h2 {
    font-size: 22px;
    padding-bottom: 15px;
  }

  ol {
    padding-bottom: 5px;
    padding-left: 10px;
  }

  p {
    padding-bottom: 10px;
  }

  img {
    margin: 15px 0;
  }

  ul {
    padding-left: 20px;

    li {
      padding-bottom: 5px;
    }
  }

  .red {
    color: red;
    font-size: 20px;
    font-weight: 700;
  }

  .bottom {
    font-size: 20px;
    font-weight: 700;

    span {
      color: red;
    }
  }
}
</style>
